import React, { useEffect, useState } from "react";
import { BannerForShimmer } from "../../utils/SvgComponents";
import { Helmet } from "react-helmet";
import DashboardCardPC from "../common/DashboardCardPC";
import Confetti from "react-confetti";
import "./Dashboard.css";
import DashboardCardMobile from "../common/DashboardCardMobile";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getDataFromStore } from "../../utils/CookiesUtils";
import { EVENT_BASEURL, LOGIN_DATA } from "../../utils/Constants";
import { apiHandler } from "../../utils/apiHandler";
import { motion } from "framer-motion";
import BackgroundImageWithBlur from "../common/image/BackgroundImageWithBlur";


const Dashboard = () => {
	const [showConfetti, setShowConfetti] = useState(false);
	const [viewportHeight, setViewportHeight] = useState(window.innerHeight);
	const [response, setResponse] = useState([]);
	const [visibleCount, setVisibleCount] = useState(0);
	const [animateNow, setAnimateNow] = useState(false);
	const [newData, setQuizData] = useState([])
	const navigate = useNavigate();
	const location = useLocation();
	const pathParts = location.pathname.split("/").filter(Boolean);
	const username = pathParts[0];
	let newID = JSON.parse(localStorage.getItem(`logindata_${username}`))
	let NewUsername = "";

	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		NewUsername = pathArray[1];
	} else {
		NewUsername = pathArray[0]
	}

	let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
	const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
	console.log(newImgUrl);
	useEffect(() => {
		localStorage.removeItem("quizgame");
		localStorage.removeItem("firms")
		localStorage.removeItem("memory")
	}, [])
	useEffect(() => {
		const animationsEnabled = localStorage.getItem(`animationsEnabled_${username}`);
		if (animationsEnabled === "true") {
			setTimeout(() => {
				setAnimateNow(true);
				localStorage.removeItem("animationsEnabled"); // clear flag
			}, 200); // slight delay ensures mount complete
		} else {
			setAnimateNow(true); // default (like on refresh)
		}
	}, []);
	useEffect(() => {
		const fetchDashBoard = async () => {
			try {

				const res = await apiHandler.post("/guest/dashboard", {
					eventId: newID?._id,
				});
				if (res) {
					setResponse(res);
				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};
		fetchDashBoard();

	}, [newID?._id])

	useEffect(() => {
		const fetchMemories = async () => {
			const memories = response?.find(item => item.category === "Memories");
			const memoriesId = memories ? memories.docId : null;
			try {
				const res = await apiHandler.post("/guest/fetch-feature", {
					_id: memoriesId,
					category: "Memories"
				});
				if (res) {
					localStorage.setItem("memory", JSON.stringify(res.memories));

				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};
		// const fetchProfile = async () => {
		// 	const memories = response?.find(item => item.category === "Firms");
		// 	const memoriesId = memories ? memories.docId : null;
		// 	try {
		// 		const res = await apiHandler.post("/guest/fetch-feature", {
		// 			_id: memoriesId,
		// 			category: "Firms"
		// 		});
		// 		console.log(res);
		// 		if (res) {
		// 			localStorage.setItem("firms", JSON.stringify(res));

		// 		}
		// 	} catch (err) {
		// 		console.error("Guest login error:", err);
		// 	}
		// };


		if (response?.length > 0) {
			// fetchMemories();
			// fetchProfile();
		}
	}, [response])


	// useEffect(() => {
	// 	const memories = response?.find(item => item.category === "QuizGame");
	// 	const memoriesId = memories ? memories.docId : null;
	// 	const fetchSquad = async () => {
	// 		try {
	// 			const res = await apiHandler.post("/guest/fetch-feature", {
	// 				_id: memoriesId,
	// 				category: "QuizGame"
	// 			});
	// 			if (res) {
	// 				console.log(res)
	// 				let data = transformQuizData(res)
	// 				const allData = [data, res];
	// 				localStorage.setItem("quizgame", JSON.stringify(allData));
	// 				console.log(data)

	// 			}
	// 		} catch (err) {
	// 			console.error("Guest login error:", err);
	// 		}
	// 	};



	// 	if(response?.length>0){
	// 		fetchSquad();
	// 	}




	// }, [response])










	useEffect(() => {
		const handleResize = () => {
			setViewportHeight(window.innerHeight);
		};

		window.addEventListener('resize', handleResize);
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		// Check if confetti has been shown before
		const confettiShown = localStorage.getItem('confettiShown');
		if (!confettiShown) {
			setShowConfetti(true);
			localStorage.setItem('confettiShown', 'true'); // Set the flag to prevent future displays
		}

		localStorage.setItem("photos_page", "");
		localStorage.setItem("hasVisitedPhotosPage", "");
	}, []);




	useEffect(() => {
		if (location.state && location.state.scrollPosition) {

			window.scrollTo(0, location.state.scrollPosition);

		}
	}, [location]);

	useEffect(() => {
		if (!response || response.length === 0) return;

		let index = 0;

		const interval = setInterval(() => {
			index = index + 2;
			setVisibleCount(index);
			if (index >= response.length) {
				clearInterval(interval);
			}
		}, 100); // 400ms delay between each

		return () => clearInterval(interval);
	}, [response]);

	const loginData = newID || '{}';
	const splash = loginData?.eventMobSplash
	const bgStyle = splash
		? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url("https://welcometowedding.com/events/${loginData?._id}/${splash}")`
		: 'none';
	console.log('bg', bgStyle)
	const containerVariants = {
		hidden: {},
		show: {
			transition: {
				staggerChildren: 0.2,
			},
		},
	};
	localStorage.setItem("open", "")

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
	};
	return (
		<div id="home">
			{showConfetti && (
				<div
					className="confetti-container fixed top-0 left-0 w-full h-full pointer-events-none z-[99] fanimate-fadeIn4"
				>
					<Confetti
						colors={['#ff726d', '#f4306d', '#b48def', '#fce18a']}
						recycle={false}
						numberOfPieces={750}
						tweenDuration={50000}
						drawShape={(ctx) => {
							// ctx.beginPath();
							// for (let i = 0; i < 22; i++) {
							const x = 4.5;
							const y = 9;
							ctx.ellipse(x, y, x / 2, y / 2, 0, 0, 2 * Math.PI);
							// }
							ctx.fill();
							ctx.stroke();
							// ctx.closePath();
						}}
					/>
				</div>
			)}
			<div className="hidden sm:block ">

				<div className="h-screen mx-auto  grid grid-cols-12 dashboard-pc padding-0 overflow-hidden h-full" >
					<div className="col-span-5 padding-0 margin-0 bg-black h-screen scroll-bar "
					>
						<motion.div
							key={location?.pathname}
							className="grid grid-cols-1 lg:grid-cols-2 pe-[25px] "
							variants={containerVariants}
							initial="hidden"
							animate={animateNow ? "show" : "hidden"}
						>
							{response && response?.slice(0, visibleCount).map((item, index) => (
								// <div
								// 	key={item.docId}
								// 	// className="col-lg-6 col-md-6 col-sm-12"		
								// >
								<motion.div
									key={index}
									variants={itemVariants}
								>
									<DashboardCardPC
										title={item.title}
										backgroundImageUrl={`https://welcometowedding.com/events/${newID?._id}/${item.titleBg}`}
										url={`/${username}/${item.category}/${item.docId}`}
									/>
								</motion.div>
								// </div>
							))}
						</motion.div>
						{visibleCount >= response.length && visibleCount != 0 && <div className="">
							<div className="uppercase text-white text-center py-2 underline underline-offset-2 cursor-pointer animate-fadeIn4">
								<Link to={`/${username}/SelfAboutUs`} className="text-white">About Us</Link>
							</div>
						</div>}
					</div>
					<div className="col-span-7 padding-0 margin-0">
						<BackgroundImageWithBlur
							src={newID?.eventWebSplash
								? `https://welcometowedding.com/events/${newID?._id}/` + newID?.eventWebSplash
								: null}
							className="dashboard-pc-main-image min-h-screen flex flex-col justify-end bg-black/50 z-0 bg-center bg-cover bg-no-repeat"

						>
							<div className="px-[40px] pb-[25px]  gap-4 gap-md-2 gap-sm-2 justify-content-center align-items-center z-1 bg-black/30">
								<div className=" text-white text-center sm:text-[30px] md:text-[45px] lg:text-[60px] font-['Baby_Giovani_Script'] pt-3">
									{newID?.eventTitle}
								</div>
								<div className="flex justify-center">
									<div className="w-3/5">
										<BannerForShimmer eventDate={newID?.eventDate} />
									</div>
								</div>
							</div>
						</BackgroundImageWithBlur>
					</div>
				</div>
			</div>

			<div className="block sm:hidden " style={{ overflow: 'scroll', height: '2000px' }}>
				<div class="overflow-scroll bg-black h-[100vh] animate-fadeIn2" style={{ height: viewportHeight }}>
					<div className="dashboard ">
						<div className="bg-black mx-auto  " >
							<div
								className="relative py-[50px] px-[40px] z-[1] before:absolute before:top-0 before:right-0 before:bottom-0 before:left-0 before:bg-black/0 before:z-[-1] animate-fadeIn"
								style={{

									backgroundImage: bgStyle,
									backgroundPosition: "center",
									backgroundSize: "cover",
								}}
							>
								<div className=" gap-4 justify-content-center align-items-center z-1 ">
									<div

										className=" text-white text-center dashboard-mobile-text text-[50px] font-['Baby_Giovani_Script'] style-script-regular" >
										{newID?.eventTitle.split('&')[0]} <br /> & <br /> {newID?.eventTitle.split('&')[1]}
									</div>
									<div className="flex justify-center">
										<BannerForShimmer eventDate={newID?.eventDate} />
									</div>
								</div>
							</div>
							<motion.div
								key={location?.pathname}
								className="grid grid-cols-1 lg:grid-cols-2  "
								variants={containerVariants}
								initial="hidden"
								animate="show"
							>
								<div className="px-[15px] fs-4">
									{response && newImgUrl &&
										response.map((item, index) => {
											console.log(newImgUrl + item.titleBg)
											return (
												<motion.div
													key={index}
													variants={itemVariants}
												>
													<DashboardCardMobile
														key={item.docId}
														title={item.title}
														backgroundImageUrl={`https://welcometowedding.com/events/${newID?._id}/` + item.titleBg}
														foreGroundImageUrl={`https://welcometowedding.com/events/${newID?._id}/` + item.titleFg}
														url={`${username}/${item.category}/${item.docId}`}
													/>
												</motion.div>
											)
										})}
								</div>
							</motion.div>
							<div className="mx-auto text-center text-[14px] uppercase underline text-white font-semibold px-3 pb-[15px] animate-fadeIn4">
								<Link to={`/${username}/SelfAboutUs`} className="text-white">About Us</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Dashboard;
